export const state = {
  width: 0,
  height: 0,
  breakpoints: {
    screenXS: 320,
    screenSM: 600,
    screenMD: 800,
    screenLG: 1024,
    screenXL: 1280
  }
}

export const getters = {
  getWindowSize: ({ width, height }) => {
    return { width, height }
  },
  getBreakpoints: ({ breakpoints }) => {
    return breakpoints
  },
  isMobile: ({ width, breakpoints }) => {
    return width <= breakpoints.screenSM
  },
  isTablet: ({ width, breakpoints }) => {
    return width <= breakpoints.screenMD
  }
}

export const mutations = {
  SET_WINDOW_SIZE: (state, { width, height }) => {
    state.width = width
    state.height = height
  }
}
